module.exports = __webpack_public_path__ + "static/media/select.40b13104.jpg";